import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import { AppState } from 'src/store';
import * as api from 'src/api/calculation/calculation';
import { TaxStatus } from 'src/admin-entity/enum/product/tax-status.enum';

export const getCalculation = createAsyncThunk(
    `calculationSlice/getCalculation`,
    async (_, { getState, rejectWithValue }) => {
        try {
            const { page, take, beginDate, endDate, taxStatus, distributor, searchType } = (getState() as AppState)
                .calculation.pagination;
            const res = await api.getCalculation(page, take, beginDate, endDate, taxStatus, distributor.id, searchType);
            return res.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    },
);

export const getCalculationSummary = createAsyncThunk(
    `calculationSlice/getCalculationSummary`,
    async (_, { getState, rejectWithValue }) => {
        try {
            const { page, take, beginDate, endDate, taxStatus, distributor, searchType } = (getState() as AppState)
                .calculation.pagination;
            const res = await api.getCalculationSummary(
                page,
                take,
                beginDate,
                endDate,
                taxStatus,
                distributor.id,
                searchType,
            );
            return res.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    },
);

const calculationSlice = createSlice({
    name: 'calculationSlice',
    initialState,
    reducers: {
        initCalculationSlice: () => {
            return initialState;
        },
        initPagination: state => {
            state.pagination.beginDate = initialState.pagination.beginDate;
            state.pagination.endDate = initialState.pagination.endDate;
            state.pagination.distributor = initialState.pagination.distributor;
            state.pagination.taxStatus = initialState.pagination.taxStatus;
            state.pagination.searchType = initialState.pagination.searchType;
        },
        updateTake: (state, action: PayloadAction<number>) => {
            state.pagination.take = action.payload;
        },
        updatePage: (state, action: PayloadAction<number>) => {
            state.pagination.page = action.payload;
        },
        updateBeginDate: (state, action: PayloadAction<string>) => {
            state.pagination.beginDate = action.payload;
        },
        updateEndDate: (state, action: PayloadAction<string>) => {
            state.pagination.endDate = action.payload;
        },
        updateTaxStatus: (state, action: PayloadAction<TaxStatus>) => {
            state.pagination.taxStatus = action.payload;
        },
        updateDistributor: (state, action: PayloadAction<{ id: number; name: string }>) => {
            state.pagination.distributor = action.payload;
        },
        updateSearchType: (state, action: PayloadAction<string>) => {
            state.pagination.searchType = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(getCalculation.fulfilled, (state, { payload }) => {
            state.calculationPage = {
                ...payload,
                list: payload.list.map(item => {
                    return {
                        ...item,
                        id: item.distributorId,
                    };
                }),
            };
        });
        builder.addCase(getCalculationSummary.fulfilled, (state, { payload }) => {
            state.calculationSummary = payload;
        });
    },
});

export default calculationSlice.reducer;
export const {
    initCalculationSlice,
    initPagination,
    updatePage,
    updateTake,
    updateBeginDate,
    updateEndDate,
    updateTaxStatus,
    updateDistributor,
    updateSearchType,
} = calculationSlice.actions;
